// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

function Cancelacion() {

  return (
    <>
      <DefaultNavbar
        routes={routes}
        sticky
      />
      <MKBox minHeight="30vh"></MKBox>
      <Card
        minHeight="30vh"
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <MKBox component="section" >
          <Container>
            <Grid
              container
              item
              flexDirection="column"
              sx={{ textAlign: "justify", my: 6, mx: "auto", px: 0.75 }}
            >
                <MKTypography variant="h4" gutterBottom fontWeight="bold" style={{textAlign: "center"}}>
                    Política de cancelaciones y devoluciones
                </MKTypography>

                <MKTypography variant="h5" gutterBottom fontWeight="bold" mt={4} style={{textAlign: "center"}}>
                    NUESTRA POLÍTICA DE GARANTÍA
                </MKTypography>

                <MKTypography variant="h5" mt={3}>
                    Nuestra política de garantía aplica de la siguiente forma:
                </MKTypography>
                <MKTypography paragraph>a. Contra defectos de fabricación de la pieza defectuosa con cambio físico.</MKTypography>
                <MKTypography paragraph>b. No se aceptarán reclamos pasados los treinta (30) días a partir de la fecha de la compra.</MKTypography>
                <MKTypography paragraph>c. Si las bombas/refacciones recibidas no corresponden con lo solicitado en su orden de compra.</MKTypography>
                <MKTypography paragraph>d. Para hacer válida la garantía del fabricante es necesario que las bombas no hayan sido desarmadas por el cliente.</MKTypography>
                <MKTypography paragraph>e. Todas las garantías serán LAB México, D.F.</MKTypography>
                <MKTypography paragraph>f. La mercancía viaja por cuenta y riesgo del comprador.</MKTypography>
                <MKTypography paragraph>g. La garantía no aplica en caso de daños sufridos durante su traslado.</MKTypography>

                <MKTypography variant="h5" mt={3}>
                    El procedimiento para la garantía es el siguiente:
                </MKTypography>
                {[...Array(7)].map((_, i) => (
                <MKTypography paragraph key={i}>
                    {`${i + 1}. ${
                    [
                        "Contra defectos de fabricación de la pieza defectuosa con cambio físico.",
                        "No se aceptarán reclamos pasados los treinta (30) días a partir de la fecha de la compra.",
                        "Si las bombas/refacciones recibidos no corresponden con lo solicitado en su orden de compra.",
                        "Para hacer válida la garantía del fabricante es necesario que las bombas no hayan sido desarmadas por el cliente.",
                        "Todas las garantías serán LAB México, D.F.",
                        "La mercancía viaja por cuenta y riesgo del comprador.",
                        "La garantía no aplica en caso de daños sufridos durante su traslado.",
                    ][i]
                    }`}
                </MKTypography>
                ))}

                <MKTypography paragraph mt={2}>
                En caso de cualquier duda, favor de contactarnos al teléfono 74 3741 0373 con el asesor o vendedor que lo haya atendido durante su solicitud.
                </MKTypography>

                <MKTypography variant="h5" gutterBottom fontWeight="bold" mt={4}>
                ENVÍOS
                </MKTypography>
                {[...Array(7)].map((_, i) => (
                <MKTypography paragraph key={i}>
                    {`${i + 1}. ${
                    [
                        "Nuestro horario de atención a clientes ya sea vía telefónica y/o en nuestras instalaciones es de Lunes a Viernes de 10:00 a.m. a 14:45 y de 16:00 a 18:00 p.m.",
                        "Las órdenes de compra enviadas vía electrónica serán embarcadas, de acuerdo al tiempo de entrega cotizado, o al siguiente día hábil siempre y cuando el horario de recepción no sea mayor a las 12:00 p.m.",
                        "Para poder liberar su orden de compra y que ésta sea embarcada el pago deberá de estar reflejado antes de las 12:00 horas.",
                        "El material ordenado será enviado por cobrar, ocurre o al domicilio que el cliente indique en su orden de compra.",
                        "ARES no se hace responsable por información errónea en el envío de sus productos.",
                        "Una vez embarcado el material se le hará llegar al cliente la guía de embarque correspondiente vía correo electrónico.",
                        "El tiempo de entrega variará dependiendo de la paquetería elegida por el cliente.",
                    ][i]
                    }`}
                </MKTypography>
                ))}

                <MKTypography variant="h5" gutterBottom fontWeight="bold" mt={4}>
                PREGUNTAS DE INTERÉS PARA ÓRDENES DE COMPRA CON TARJETA DE CRÉDITO
                </MKTypography>
                <MKTypography variant="subtitle1" fontWeight="bold" mt={2}>
                ¿Por qué debo proporcionar mis datos generales (teléfono y dirección)?
                </MKTypography>
                <MKTypography paragraph>
                Tu teléfono es útil para que nuestra área de ventas y la paquetería se comuniquen contigo para informarte cualquier situación sobre tu compra. Tu dirección completa nos permite hacer tu factura con todos los datos requeridos, así como, para que la mensajería encuentre el lugar de entrega rápidamente.
                </MKTypography>

                <MKTypography variant="subtitle1" fontWeight="bold" mt={2}>
                ¿Por qué me piden mi R.F.C. cuando estoy registrando una dirección de envío?
                </MKTypography>
                <MKTypography paragraph>
                Necesitamos tu código del Registro Federal de Contribuyentes (R.F.C.) para elaborar tu factura, esto incluye el dato correcto y específico con la dirección a la que quieres que llegue.
                </MKTypography>

                <MKTypography variant="h5" gutterBottom fontWeight="bold" mt={4}>
                AVISO DE PRIVACIDAD
                </MKTypography>
                <MKTypography paragraph fontWeight="bold">
                RESPONSABLE DE LA PROTECCIÓN DE SUS DATOS PERSONALES
                </MKTypography>
                <MKTypography paragraph>
                ABASTECEDORA DE REFACCIONES Y SERVICIOS ARES (ARES), con domicilio en VILLA DE TEZONTEPEC CENTRO, HIDALGO, CP 43880, es responsable del tratamiento de sus datos personales y se compromete a asegurar la privacidad de la información personal obtenida a través de sus servicios en línea y otros medios permitidos por la ley.
                </MKTypography>

                <MKTypography paragraph fontWeight="bold">Cómo contactarnos:</MKTypography>
                <MKTypography paragraph>Domicilio: VILLA DE TEZONTEPEC CENTRO, HIDALGO, CP 43880</MKTypography>
                <MKTypography paragraph>Correo Electrónico: ventas@bombasares.com.mx</MKTypography>
                <MKTypography paragraph>Teléfono: 74 3741 0373</MKTypography>

                <MKTypography paragraph fontWeight="bold" mt={3}>¿PARA QUÉ FINES RECABAMOS Y UTILIZAMOS SUS DATOS PERSONALES?</MKTypography>
                <MKTypography paragraph>Sus datos personales serán utilizados para las siguientes finalidades:</MKTypography>
                {[
                "Proveer los servicios y productos requeridos por usted;",
                "Informar sobre cambios o nuevos productos o servicios que estén relacionados con lo contratado o adquirido por usted;",
                "Dar cumplimiento a obligaciones contraídas con usted;",
                "Evaluar la calidad del servicio;",
                "Realizar estudios internos sobre hábitos de consumo de nuestros clientes.",
                "Desarrollar nuevos productos y servicios;",
                "Informar respecto de promociones, ofertas, novedades y eventos especiales.",
                "Permitir el acceso a cursos, eventos y/o actividades laborales a las que se haya inscrito.",
                ].map((item, index) => (
                <MKTypography paragraph key={index}>• {item}</MKTypography>
                ))}

                <MKTypography paragraph>
                Nos comprometemos a no transferir su información personal a terceros sin su consentimiento, salvo las excepciones previstas en el artículo 37 de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares.
                </MKTypography>

                <MKTypography variant="subtitle1" fontWeight="bold" mt={2}>
                MODIFICACIONES AL AVISO DE PRIVACIDAD
                </MKTypography>
                <MKTypography paragraph>
                ABASTECEDORA DE REFACCIONES Y SERVICIOS ARES (ARES), se reserva el derecho de efectuar en cualquier momento, modificaciones o actualizaciones al presente aviso de privacidad.
                </MKTypography>

                <MKTypography paragraph fontWeight="bold" mt={2}>
                ACEPTACIÓN DE TÉRMINO
                </MKTypography>
                <MKTypography paragraph>
                Esta declaración de Confidencialidad / Privacidad está sujeta a los términos y condiciones de ARES.
                </MKTypography>

                <MKTypography paragraph fontWeight="bold" mt={2}>
                ¿ANTE QUIÉN PUEDE PRESENTAR SUS QUEJAS Y DENUNCIAS POR EL TRATAMIENTO INDEBIDO DE SUS DATOS PERSONALES?
                </MKTypography>
                <MKTypography paragraph>
                Si usted considera que su derecho de protección de datos personales ha sido lesionado,
                puede interponer la queja correspondiente ante el IFAI: www.ifai.org.mx.
                </MKTypography>
            </Grid>
          </Container>
        </MKBox>
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Cancelacion;
